import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError, finalize } from 'rxjs/operators';
import { StatusRepository } from '../../../infrastructure/repositories/status.repository';
import { StatusState } from '../../states/status.state';
import { ToggleStatusActiveResult } from './toggle-status-active.result';

@Injectable()
export class ToggleStatusActiveUseCase {
  private readonly repository = inject(StatusRepository);
  private readonly state = inject(StatusState);

  execute(id: string, isActive: boolean): Observable<ToggleStatusActiveResult> {
    this.state.setSavingStatusActive(true);

    return this.repository.toggleStatusActive(id, isActive).pipe(
      map(() => ({ success: true })),
      catchError((error) => {
        this.state.setError(error.message || 'Failed to toggle status');
        throw error;
      }),
      finalize(() => {
        this.state.setSavingStatusActive(false);
      }),
    );
  }
}
